import React, { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  CryptoImage,
  CryptoMainImage,
  ForexImage,
  ForexMainImage,
  IndexImage,
  IndexMainImage,
  RawImage,
  RawMainImage,
  StockImage,
  StockMainImage,
} from 'src/assets';
import './financialTab.scss';

export const FinancialTab = () => {
  const { t } = useTranslation();

  const [tab, setTab] = useState('stock');

  const tabOptions = [
    {
      image: StockImage,
      value: 'stock',
    },
    {
      image: ForexImage,
      value: 'forex',
    },
    {
      image: CryptoImage,
      value: 'crypto',
    },
    {
      image: IndexImage,
      value: 'index',
    },
    {
      image: RawImage,
      value: 'raw',
    },
  ];

  const tabItem = {
    stock: {
      title: `financialTab:${tab}:title`,
      subTitle: `financialTab:${tab}:subTitle`,
      wrappedText: `financialTab:${tab}:wrappedText`,
      afterWrapped: `financialTab:${tab}:afterWrapped`,
      image: StockMainImage,
    },
    forex: {
      title: `financialTab:${tab}:title`,
      subTitle: `financialTab:${tab}:subTitle`,
      wrappedText: `financialTab:${tab}:wrappedText`,
      afterWrapped: `financialTab:${tab}:afterWrapped`,
      image: ForexMainImage,
    },
    crypto: {
      title: `financialTab:${tab}:title`,
      subTitle: `financialTab:${tab}:subTitle`,
      wrappedText: `financialTab:${tab}:wrappedText`,
      afterWrapped: `financialTab:${tab}:afterWrapped`,
      image: CryptoMainImage,
    },
    index: {
      title: `financialTab:${tab}:title`,
      subTitle: `financialTab:${tab}:subTitle`,
      wrappedText: `financialTab:${tab}:wrappedText`,
      afterWrapped: `financialTab:${tab}:afterWrapped`,
      image: IndexMainImage,
    },
    raw: {
      title: `financialTab:${tab}:title`,
      subTitle: `financialTab:${tab}:subTitle`,
      wrappedText: `financialTab:${tab}:wrappedText`,
      afterWrapped: `financialTab:${tab}:afterWrapped`,
      image: RawMainImage,
    },
  };

  const onSelectTab = useCallback(
    (tab) => () => {
      setTab(tab);
    },
    [],
  );

  return (
    <div className="financial-tab">
      <div className="financial-tab-wrapper">
        {tabOptions.map((item) => (
          <div
            key={item.value}
            className={`financial-tab-item ${tab === item.value ? 'active-tab' : 'inactive-tab'}`}
            onClick={onSelectTab(item.value)}
          >
            <img src={item.image} alt={item.image} className="financial-tab-image" />
            <div className="financial-tab-item-subtitle">
              {t(`financialTab:${item.value}:tabTitle`)}
            </div>
          </div>
        ))}
      </div>
      <div className="financial-tab-content">
        <div className="financial-tab-content-wrapper">
          <h2 className="financial-tab-title">{t(tabItem[tab].title)}</h2>
          <div className="financial-tab-subtitle">
            <Trans i18nKey={tabItem[tab].subTitle} />
          </div>
          <div className="financial-tab-box">
            <Trans i18nKey={tabItem[tab].wrappedText} />
          </div>
          {tabItem[tab].afterWrapped && (
            <div className="financial-tab-subtitle">
              <Trans i18nKey={tabItem[tab].afterWrapped} />
            </div>
          )}
        </div>

        <img
          src={tabItem[tab].image}
          alt={tabItem[tab].image}
          className="financial-tab-content-image"
        />
      </div>
    </div>
  );
};
